import axios from "axios"

function getLiveSession({ id }) {
    return axios.get(`api/v1/live-sessions/${id}`)
}

function getCall({ id }) {
    return axios.get(`api/v1/live-sessions/${id}/call`)
}

function makeCall({ id }, value) {
    return axios.post(`api/v1/live-sessions/${id}/call`, value)
}

function joinCall({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/call/join`)
}

function leaveCall({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/call/leave`)
}

function callKeepAlive({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/call/keep-alive`)
}

function raiseHand({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/raise-hand`, data)
}

function lowerHands({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/lower-hands`, data)
}

function lowerAllHands({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/lower-all-hands`)
}

function createConversation({}, data) {
    return axios.post(`api/v2/live-sessions/conversations`, data)
}

function respondConversation({ id }, data) {
    return axios.post(`api/v2/live-sessions/conversations/${id}/response`, data)
}

function giveAgentFeedback({ id }, data) {
    return axios.post(`api/v2/live-sessions/conversations/${id}/feedback`, data)
}

function leaveLiveSession({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/leave`)
}

function finalizeLiveSession({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/finalize`)
}

function sendSatisfaction({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/send-satisfaction`, data)
}

function sendLiveQuality({ id }, data) {
    return axios.post(
        `api/v1/live-occurrences/${id}/send-quality?_method=PUT`,
        data
    )
}

function sendStudentComment({ id }, data) {
    return axios.put(`api/v1/live-sessions/${id}/send-student-comment`, data)
}

function getTodayLiveReports({ id }) {
    return axios.get(`api/v1/live-sessions/${id}/today-live-reports`)
}

function getTodayLiveReport({ id }) {
    return axios.get(`api/v1/live-sessions/${id}/today-live-report`)
}

// Le quiz de fin de séance de cette sortie du live : tiré à la première demande, le même ensuite ; null sans quiz.
function getEndOfLiveQuiz({ id }) {
    return axios.post(`api/v1/live-sessions/${id}/end-of-live-quiz`)
}

// Une réponse au quiz de fin de séance ; la dernière rapporte le pétale.
function answerEndOfLiveQuiz({ quizId }, data) {
    return axios.post(`api/v1/end-of-live-quizzes/${quizId}/answers`, data)
}

function getTodayLiveOccurrence({ id }) {
    return axios.get(`api/v1/live-sessions/${id}/today-live-occurrence`)
}

function getTodayTutorLiveOccurrences({ id }) {
    return axios.get(`api/v1/tutors/${id}/today-live-occurrence`)
}

function getLiveOccurrence({ id }) {
    return axios.get(`api/v1/live-occurrences/${id}`)
}

function setSoundMode({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/sound-mode`, data)
}

function setCamMode({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/camonoff`, data)
}

function setVoiceRecordingActivity({ id }, data) {
    return axios.post(
        `api/v1/live-sessions/${id}/voice-recording-activity`,
        data
    )
}

function storeEventsBatch({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/events-batch`, data)
}

function getLiveSessions() {
    return axios.get(`api/v1/live-sessions`)
}

function moveSession({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/move-session`, data)
}

function reportAbsence({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/report-absence`, data)
}

function getTutorAbsenceImpact({ id }, {}, params) {
    return axios.get(`api/v1/live-sessions/${id}/absence-impact`, { params })
}

function reportAbsenceAsStudent({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/manage-attendance-flag`, data)
}

function reportAbsenceAsParent({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/new-attendance-flag`, data)
}

function recoverAbsenceAsStudent({ id }, data) {
    return axios.post(`api/v1/attendance-flags/${id}/recover`, data)
}

function recoverAbsenceAsParent({ id }, data) {
    return axios.post(`api/v1/attendance-flags/${id}/recover-as-parent`, data)
}

function autoRecoveryTutorLate({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/auto-recovery`, data)
}

function autoRecoveryFallback({ id }, data) {
    return axios.post(`api/v1/live-sessions/${id}/auto-recovery/fallback`, data)
}

function getAllMyNextLiveSessions({}, {}, params) {
    return axios.get(`api/v1/next-live-sessions`, { params })
}

function getAllMyNextLiveSessionsAsParent({}, {}, params) {
    return axios.get(`api/v1/user/next-live-sessions`, { params })
}

function getRecoveryPossibilities({}, {}, params) {
    return axios.get(`api/v1/recovery-possibilities`, { params })
}

function getRecoveryPossibilitiesAsParent({}, {}, params) {
    return axios.get(`api/v1/user/recovery-possibilities`, { params })
}

function finishConversation({ conversation_id }, data) {
    return axios.post(
        `api/v2/live-sessions/conversations/${conversation_id}/finish`,
        data
    )
}

// L'activité qu'une conversation a fait générer (`null` tant que le travail tourne, ou s'il a échoué).
function getGeneratedActivity({ conversation_id }) {
    return axios.get(`api/v2/live-sessions/conversations/${conversation_id}/generated-activity`)
}

function awardCheckpointPetal({ conversation_id }) {
    return axios.post(
        `api/v2/live-sessions/conversations/${conversation_id}/award-checkpoint-petal`
    )
}

function deleteLiveSatisfactionRecord({ id }) {
    return axios.post(
        `api/v1/live-occurrences/${id}/delete-live-satisfaction-record`
    )
}

function updateChapterOccurrence({ id }, { student_id, chapter_id }) {
    return axios.post(`api/v1/live-occurrences/${id}/update-chapter`, {
        student_id,
        chapter_id,
    })
}

function updateOccurrenceSubjects({ id }, { student_id, subject_ids }) {
    return axios.post(`api/v1/live-occurrences/${id}/update-subjects`, {
        student_id,
        subject_ids,
    })
}

function getQualityClosure({ id }) {
    return axios.get(`api/v1/live-occurrences/${id}/quality-closure`)
}

function saveQualityClosureComment({ id }, data) {
    return axios.post(
        `api/v1/live-occurrences/${id}/quality-closure-comment`,
        data
    )
}

function getStudentPreCallData({ id }) {
    return axios.get(`api/v1/live-sessions/${id}/student-pre-call`)
}

function getMakeupOccurrences({ substitutionId }, data) {
    return axios.get(
        `api/v1/substitutions/${substitutionId}/makeup-occurrences`,
        {
            params: data,
        }
    )
}

function selectMakeupOccurrence({ substitutionId }, data) {
    return axios.post(
        `api/v1/substitutions/${substitutionId}/select-makeup-occurrence`,
        data
    )
}

function getSubstitutionAbsenceSummary({}, {}, params) {
    return axios.get(`api/v1/tutor/substitution-absence-summary`, { params })
}

export const liveService = {
    getLiveSession,
    getCall,
    makeCall,
    joinCall,
    leaveCall,
    raiseHand,
    lowerHands,
    lowerAllHands,
    setSoundMode,
    setCamMode,
    setVoiceRecordingActivity,
    storeEventsBatch,
    callKeepAlive,
    leaveLiveSession,
    finalizeLiveSession,
    sendSatisfaction,
    getTodayLiveReports,
    getTodayTutorLiveOccurrences,
    getTodayLiveReport,
    getEndOfLiveQuiz,
    answerEndOfLiveQuiz,
    sendLiveQuality,
    sendStudentComment,
    getLiveSessions,
    moveSession,
    reportAbsence,
    getTutorAbsenceImpact,
    getTodayLiveOccurrence,
    getLiveOccurrence,
    reportAbsenceAsStudent,
    reportAbsenceAsParent,
    recoverAbsenceAsStudent,
    recoverAbsenceAsParent,
    autoRecoveryTutorLate,
    autoRecoveryFallback,
    getAllMyNextLiveSessions,
    getAllMyNextLiveSessionsAsParent,
    getRecoveryPossibilities,
    getRecoveryPossibilitiesAsParent,
    createConversation,
    respondConversation,
    giveAgentFeedback,
    finishConversation,
    getGeneratedActivity,
    awardCheckpointPetal,
    getQualityClosure,
    saveQualityClosureComment,
    deleteLiveSatisfactionRecord,
    updateChapterOccurrence,
    updateOccurrenceSubjects,
    getStudentPreCallData,
    getMakeupOccurrences,
    selectMakeupOccurrence,
    getSubstitutionAbsenceSummary,
}
